import React, {createContext, useContext, useMemo, useState} from 'react'
import {useApiAuthLogout} from "@/api/auth";
import {clearTokensAndRedirect} from "@/lib/services/tokenService";

const AuthContext = createContext({})


export function AuthProvider({children}) {
    const [user, setUser] = useState({})
    const [academy, setAcademy] = useState();
    const [userAcademy, setUserAcademy] = useState()
    const [role, setRole] = useState();
    const [dashboard, setDashboard] = useState();
    const [breadcrumb, setBreadcrumb] = useState([]);

    const {mutate: authLogout, isPending} = useApiAuthLogout()

    const logout = async () => {
        authLogout({}, {
            onSuccess: function () {
                clearTokensAndRedirect()
            }
        })
    };

    const value = useMemo(() => (
        {
            user,
            setUser,
            academy,
            setAcademy,
            userAcademy,
            setUserAcademy,
            role,
            logout,
            setRole,
            dashboard,
            setDashboard,
            breadcrumb,
            setBreadcrumb
        }
    ), [
        user,
        setUser,
        academy,
        setAcademy,
        userAcademy,
        role,
        setRole,
        dashboard,
        setDashboard,
        breadcrumb,
        setBreadcrumb
    ])

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
    return useContext(AuthContext);
};
